import cn from 'classnames';
import SelectableCard from 'components/selectable-card';
import { CATEGORIES } from '../constants';
import { useSubscriptionFunnel } from '../state';
import styles from './food-type-selector.module.css';
import { FC } from 'react';

const FoodTypeSelector: FC = () => {
  const { selectedCategories, petType, toggleFoodType, applicableCategories } =
    useSubscriptionFunnel();

  return (
    <div className={cn(styles.slider, 'mt-4')}>
      {applicableCategories.map((category) => (
        <div key={category} className="shrink-0">
          <SelectableCard
            label={category}
            src={`/images/futterabo/category-${petType ?? 'dog'}-${category.toLowerCase()}.jpeg`}
            sizes="(min-width: 1024px) 296px, 50vw"
            selected={selectedCategories.includes(CATEGORIES[category])}
            onSelect={() => {
              toggleFoodType(CATEGORIES[category]);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default FoodTypeSelector;
